'use es6';

import { Fragment } from 'react';
import I18n from 'I18n';
import formatName from 'I18n/utils/formatName';
import PropTypes from 'prop-types';
import { propertyLabelTranslator } from 'property-translator/propertyTranslator';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import UISelect from 'UIComponents/input/UISelect';
import { UserPropertyOptions } from '../../../constants/properties';
import { i18nKey } from '../../../utils/properties';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function GlobalDefaultOwnerField({
  owners,
  defaultValue,
  localDefaultValue,
  settingsLink
}) {
  const owner = owners.find(({
    ownerId
  }) => {
    if (defaultValue) {
      return ownerId === parseFloat(defaultValue);
    }
    return ownerId === parseFloat(localDefaultValue);
  });
  return /*#__PURE__*/_jsx(UIFormControl, {
    className: "m-top-0",
    tooltip: I18n.text(i18nKey('userFallbackHelp')),
    tooltipPlacement: "bottom right",
    label: I18n.text(i18nKey('fallbackUserLabel')),
    help: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: i18nKey('fallbackUserLabelHelp'),
      options: {
        href: settingsLink
      }
    }),
    children: /*#__PURE__*/_jsx(UITextInput, {
      readOnly: true,
      value: owner && formatName(owner)
    })
  });
}
export default function UserProperties({
  categoryCanHaveGlobalDefaultValue,
  owners,
  defaultValue,
  localDefaultValue,
  selectedUserProperty,
  settingsLink,
  dropdownClassName,
  onUserPropertySelect
}) {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [categoryCanHaveGlobalDefaultValue && /*#__PURE__*/_jsx(GlobalDefaultOwnerField, {
      owners: owners,
      defaultValue: defaultValue,
      localDefaultValue: localDefaultValue,
      settingsLink: settingsLink
    }), /*#__PURE__*/_jsx(UIFormControl, {
      className: "m-top-2 p-bottom-2",
      label: I18n.text(i18nKey('userPropertyLabel')),
      children: /*#__PURE__*/_jsx(UISelect, {
        dropdownClassName: dropdownClassName,
        menuStyle: {
          maxHeight: 300
        },
        onChange: onUserPropertySelect,
        options: UserPropertyOptions.map(({
          value,
          text
        }) => ({
          value,
          text: propertyLabelTranslator(text)
        })),
        "data-test-id": "user-property-select",
        placeholder: I18n.text(i18nKey('propertyPlaceholder')),
        value: selectedUserProperty,
        filterOptions: true
      })
    })]
  });
}
UserProperties.propTypes = {
  categoryCanHaveGlobalDefaultValue: PropTypes.bool.isRequired,
  owners: PropTypes.array,
  defaultValue: PropTypes.string,
  localDefaultValue: PropTypes.string,
  selectedUserProperty: PropTypes.string.isRequired,
  settingsLink: PropTypes.string.isRequired,
  dropdownClassName: PropTypes.string,
  onUserPropertySelect: PropTypes.func.isRequired
};